import { render, staticRenderFns } from "./RulePackTip.vue?vue&type=template&id=6b9c5d68&scoped=true&"
import script from "./RulePackTip.vue?vue&type=script&lang=js&"
export * from "./RulePackTip.vue?vue&type=script&lang=js&"
import style0 from "./RulePackTip.vue?vue&type=style&index=0&id=6b9c5d68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9c5d68",
  null
  
)

export default component.exports